<div class="tcf">
  <header class="tcf-header">
    <h2>New user</h2>
  </header>

  <div class="tcf-body" [formGroup]="form">
    <label class="field">
      <span class="field-label">Email address <em>*</em></span>
      <input type="email" formControlName="emailAddress" [class.invalid]="emailError" />
      <span class="field-error" *ngIf="form.get('emailAddress')?.touched && form.get('emailAddress')?.hasError('required')">Required</span>
      <span class="field-error" *ngIf="form.get('emailAddress')?.hasError('email')">Invalid email</span>
      <span class="field-error" *ngIf="emailError">{{ emailError }}</span>
    </label>

    <label class="field">
      <span class="field-label">Display name (optional)</span>
      <input type="text" formControlName="displayName" autocomplete="off" />
    </label>

    <label class="field">
      <span class="field-label">Username — alternate login (optional)</span>
      <input type="text" formControlName="userName" autocomplete="off" />
    </label>

    <label class="field">
      <span class="field-label">Temporary password <em>*</em></span>
      <input type="password" formControlName="password" autocomplete="new-password" />
      <span class="field-error" *ngIf="form.get('password')?.touched && form.get('password')?.hasError('required')">Required</span>
      <span class="field-error" *ngIf="form.get('password')?.hasError('minlength')">Minimum 8 characters</span>
    </label>

    <p class="tcf-error" *ngIf="error">{{ error }}</p>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary" [disabled]="form.invalid || submitting" (click)="submit()">
      {{ submitting ? 'Creating…' : 'Create' }}
    </button>
  </footer>
</div>
